import { isDev } from "./config";
export const debug = (msg) => {
    if (isDev)
        console.log(msg);
};
